import Vue from 'vue'

export default {
  getIntegrationProviders(query) {
    return Vue.http.get('app-services/v2/integration-provider', {
      params: query
    })
  }
}
